import { MeetingMessageModel } from '@/types';

export interface MeetingMessageWithFormattedTimestampModel extends MeetingMessageModel {
    formattedTimestamp: string;
}
